/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
  });

  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });
  document.addEventListener('theme:resize', e => { console.log(e); });

  // ============================================================
  // Delivery urgency countdown timer
  // ============================================================
  function initDeliveryTimer() {
    if (!document.body.classList.contains('template-product')) return;
    var TEST_MODE = false;
    var timerHTML = '<div class="delivery-timer">Order within <span class="delivery-timer__countdown"></span> for next-day delivery!</div>';
    var buttonBlock = document.querySelector('.product__block__buttons');
    if (buttonBlock) { buttonBlock.insertAdjacentHTML('afterend', timerHTML); }
    function updateTimer() {
      var now = new Date();
      var ukParts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', hour: 'numeric', minute: 'numeric', weekday: 'narrow', hour12: false
      }).formatToParts(now);
      var ukHour = parseInt(ukParts.find(p => p.type === 'hour').value);
      var ukMin = parseInt(ukParts.find(p => p.type === 'minute').value);
      var countdown = document.querySelector('.delivery-timer__countdown');
      var timer = document.querySelector('.delivery-timer');
      var day = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/London' })).getDay();
      if (!TEST_MODE) {
        if (day === 0 || day === 6 || (day === 5 && ukHour >= 14)) {
          if (timer) timer.style.visibility = 'hidden'; return;
        }
      }
      var minsUntilCutoff = ((14 - ukHour) * 60) - ukMin;
      if (!TEST_MODE && minsUntilCutoff <= 0) {
        if (timer) timer.style.visibility = 'hidden'; return;
      }
      if (TEST_MODE && minsUntilCutoff <= 0) { minsUntilCutoff = 150; }
      var h = Math.floor(minsUntilCutoff / 60);
      var m = minsUntilCutoff % 60;
      if (countdown) countdown.textContent = h + 'h ' + m + 'm';
      if (timer) timer.style.visibility = 'visible';
    }
    updateTimer();
    setInterval(updateTimer, 60000);
  }
  document.addEventListener('DOMContentLoaded', initDeliveryTimer);

  // ============================================================
  // SUBSCRIPTION WIDGET — hide "Save up to 10%" green badge
  // ============================================================
  function initHideBadge() {
    if (!document.body.classList.contains('template-product')) return;
    var attempts = 0;
    var poll = setInterval(function() {
      attempts++;
      var rcEl = document.querySelector('recharge-subscription-widget');
      var shadow = rcEl ? rcEl.shadowRoot : null;
      if (shadow || attempts > 30) {
        clearInterval(poll);
        if (!shadow) return;
        var sheet = new CSSStyleSheet();
        sheet.replaceSync('.rc-purchase-option__badge { display: none !important; }');
        var sheets = Array.prototype.slice.call(shadow.adoptedStyleSheets);
        sheets.push(sheet);
        shadow.adoptedStyleSheets = sheets;
      }
    }, 200);
  }
  document.addEventListener('DOMContentLoaded', initHideBadge);
  // ============================================================
  // END — hide badge
  // ============================================================

  // ============================================================
  // SUBSCRIPTION WIDGET — typography, spacing, borders, text
  // ============================================================
  function initWidgetStyles() {
    if (!document.body.classList.contains('template-product')) return;
    var attempts = 0;
    var poll = setInterval(function() {
      attempts++;
      var rcEl = document.querySelector('recharge-subscription-widget');
      var shadow = rcEl ? rcEl.shadowRoot : null;
      var rcBenefits = shadow ? shadow.querySelector('rc-benefits') : null;
      var benefitsShadow = rcBenefits ? rcBenefits.shadowRoot : null;
      var rcSellingPlans = shadow ? shadow.querySelector('rc-selling-plans') : null;
      var sellingsShadow = rcSellingPlans ? rcSellingPlans.shadowRoot : null;
      if ((shadow && benefitsShadow && sellingsShadow) || attempts > 30) {
        clearInterval(poll);
        if (!shadow) return;

        // --------------------------------------------------------
        // Main widget — titles, prices, spacing, borders
        // --------------------------------------------------------
        var mainSheet = new CSSStyleSheet();
        mainSheet.replaceSync([
          '.rc-purchase-option__subscription .rc-purchase-option__label { font-size: 16px !important; font-weight: 700 !important; color: #111111 !important; }',
          '.rc-selection__onetime .rc-purchase-option__label { font-size: 16px !important; font-weight: 700 !important; color: #111111 !important; }',
          '.rc-price:not(.strike-through) { font-size: 20px !important; font-weight: 700 !important; color: #111111 !important; }',
          '.rc-price.strike-through { font-size: 14px !important; font-weight: 400 !important; color: #9CA3AF !important; text-decoration: line-through !important; }',
          '.rc-purchase-option__subscription { border: 1px solid #2F2F2F !important; }',
          '.rc-selection__onetime { border: 1px solid #A3A3A3 !important; }',
          '.rc-selection__root { gap: -4px !important; display: flex !important; flex-direction: column !important; }',
          '.rc-purchase-option__sub-container { margin-top: -4px !important; }'
        ].join(' '));
        var sheets = Array.prototype.slice.call(shadow.adoptedStyleSheets);
        sheets.push(mainSheet);
        shadow.adoptedStyleSheets = sheets;

        // --------------------------------------------------------
        // Benefits shadow DOM — title, bullets, spacing
        // --------------------------------------------------------
        if (benefitsShadow) {
          var benefitsSheet = new CSSStyleSheet();
          benefitsSheet.replaceSync([
            'p strong { font-size: 14px !important; font-weight: 600 !important; color: #111111 !important; }',
            'ul { margin-top: 12px !important; padding: 0 !important; list-style: none !important; }',
            'li { font-size: 14px !important; font-weight: 400 !important; color: #374151 !important; margin-bottom: 8px !important; }',
            'li:last-child { margin-bottom: 0 !important; }'
          ].join(' '));
          var bSheets = Array.prototype.slice.call(benefitsShadow.adoptedStyleSheets);
          bSheets.push(benefitsSheet);
          benefitsShadow.adoptedStyleSheets = bSheets;

          // Rename "How subscriptions works:"
          var titleEl = benefitsShadow.querySelector('p strong');
          if (titleEl && titleEl.textContent.toLowerCase().includes('how subscription')) {
            titleEl.textContent = 'Subscription benefits';
          }
        }

        // --------------------------------------------------------
        // Sellings shadow DOM — Deliver every + dropdown
        // --------------------------------------------------------
        if (sellingsShadow) {
          var sellingsSheet = new CSSStyleSheet();
          sellingsSheet.replaceSync([
            '.rc-plans__label { font-size: 14px !important; font-weight: 600 !important; color: #111111 !important; }',
            '.rc-plans-dropdown { margin-top: 8px !important; }',
            '.rc-plans-dropdown__select { font-size: 14px !important; font-weight: 400 !important; color: #111111 !important; border: 1px solid #A3A3A3 !important; border-radius: 6px !important; padding: 8px 12px !important; }'
          ].join(' '));
          var sSheets = Array.prototype.slice.call(sellingsShadow.adoptedStyleSheets);
          sSheets.push(sellingsSheet);
          sellingsShadow.adoptedStyleSheets = sSheets;

          // Clean up dropdown option text
          var select = sellingsShadow.querySelector('select');
          if (select) {
            Array.from(select.options).forEach(function(opt) {
              opt.text = opt.text.replace(/^(\d+)\s*(month|week|day)s?.*/i, '$1 $2');
            });
          }
        }
      }
    }, 200);
  }
  document.addEventListener('DOMContentLoaded', initWidgetStyles);
  // ============================================================
  // END — widget typography, spacing, borders
  // ============================================================

  // ============================================================
  // JUDGE.ME — Header reformat, layout fix, stars reorder,
  //            image spacing fix
  // ============================================================

  // Reorder header: number first, then stars
  // Change "(13 reviews)" to "Based on 13 reviews"
  function reformatJudgemeHeader() {
    var display = document.querySelector('.jm-average-rating-display .jm-cluster');
    if (!display || display.dataset.reformatted) return;
    var stars = display.querySelector('.jm-star-rating');
    var texts = display.querySelectorAll('p.jm-text');
    var scoreEl = texts[0];  // "4.6"
    var countEl = texts[1];  // "(13 reviews)"
    if (!stars || !scoreEl || !countEl) return;
    display.insertBefore(scoreEl, stars);
    countEl.textContent = countEl.textContent.replace(/\((\d[\d,]*)\s*reviews?\)/i, 'Based on $1 reviews');
    display.dataset.reformatted = 'true';
  }

  // Fix review body layout after avatar removed
// Fix review body layout after avatar removed
  function fixJudgemeLayout() {
    document.querySelectorAll('.jm-review-item__body').forEach(function(el) {
      if (el.dataset.layoutFixed) return;
      el.style.setProperty('--cluster-space', '0px', 'important');
      el.style.setProperty('--cluster-justify', 'flex-start', 'important');
      el.style.setProperty('flex-direction', 'column', 'important');
      el.style.setProperty('gap', '8px', 'important');
      el.dataset.layoutFixed = 'true';
    });

    // 🟢 PADDING-GAP FIX: Judge.me renders .jm-review-item__content as a CSS grid with
    // oversized fixed rows. Once moveJudgemeStars/moveJudgemeImages inject children into
    // it, each lands in a huge grid cell -> the big empty gaps. Reset it to a plain
    // vertical stack so name -> stars -> text -> images sit tight together.
    document.querySelectorAll('.jm-review-item__content').forEach(function(el) {
      if (el.dataset.contentFixed) return;
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-direction', 'column', 'important');
      el.style.setProperty('gap', '8px', 'important');
      el.style.setProperty('flex', '0 0 auto', 'important');   // 🟢 kills the flex-basis:300px that forced every card to 300px tall
      el.style.setProperty('grid-template-rows', 'none', 'important');
      el.style.setProperty('grid-template-columns', 'none', 'important');
      el.dataset.contentFixed = 'true';
    });
  }

  // Move stars below name/date inside each review card
  function moveJudgemeStars() {
    document.querySelectorAll('.jm-review-item__content').forEach(function(content) {
      if (content.dataset.starsReordered) return;
      var starsCluster = content.children[0];
      var reviewerInfo = content.querySelector('.jm-reviewer-info');
      var reviewContent = content.querySelector('.jm-review-content');
      if (!starsCluster || !reviewerInfo || !reviewContent) return;
      content.insertBefore(starsCluster, reviewContent);
      content.dataset.starsReordered = 'true';
    });
  }

  // Move review images from outside .jm-review-item__content into it,
  // so desktop CSS grid can place them in the right column.
  // Runs on desktop only (≥768px). Idempotent — safe to run repeatedly.
  function moveJudgemeImages() {
    if (!window.matchMedia('(min-width: 768px)').matches) return;
    document.querySelectorAll('.jm-review-item').forEach(function(reviewItem) {
      var outerStack = reviewItem.querySelector(':scope > .jm-stack--space-400');
      if (!outerStack) return;
      var body = outerStack.querySelector(':scope > .jm-review-item__body');
      if (!body) return;
      var content = body.querySelector(':scope > .jm-review-item__content');
      if (!content) return;

      // Find clusters that are siblings of body (direct children of outerStack, not body itself)
      var siblingClusters = [].slice.call(outerStack.children).filter(function(c) {
        return c !== body;
      });

      // Move any cluster that contains an image into content
      siblingClusters.forEach(function(cluster) {
        if (cluster.querySelector('img') || cluster.querySelector('.jm-frame')) {
          content.appendChild(cluster);
        }
      });
    });
  }

  // Fix space below images in review cards
  function fixJudgemeImageSpacing() {
    document.querySelectorAll('.jm-review-item').forEach(function(item) {
      item.style.setProperty('padding-bottom', '0px', 'important');
      var imgCluster = item.querySelector('.jm-cluster:has(.jm-media-thumbnail-list__thumbnail)');
      if (imgCluster) imgCluster.style.setProperty('margin-top', '0px', 'important');
    });
  }

  // Run all functions
  function runAllJudgeme() {
    reformatJudgemeHeader();
    fixJudgemeLayout();
    moveJudgemeStars();
    moveJudgemeImages();
    fixJudgemeImageSpacing();
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Poll until widgets are in the DOM, then run
    var attempts = 0;
    var poll = setInterval(function() {
      attempts++;
      var ready = document.querySelector('.jm-review-item__content') &&
                  document.querySelector('.jm-average-rating-display .jm-cluster');
      if (ready) {
        runAllJudgeme();
        clearInterval(poll);
      }
      if (attempts > 33) clearInterval(poll);
    }, 300);

    // Also run when Judge.me fires its own load event
    document.addEventListener('jdgm.all_widgets.load', runAllJudgeme);

    // Watch for new reviews loaded via "Load more" button
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) runAllJudgeme();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
  
  // Fix accordion close stutter — ensure transition-duration stays during close
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.product-accordion .accordion__title');
  if (!btn) return;
  const isOpen = btn.classList.contains('accordion-is-open');
  if (isOpen) {
    const body = btn.closest('.accordion__wrapper').querySelector('.accordion__body');
    body.style.transitionDuration = '300ms';
  }
});

/* ============================================================ */
/* JUDGE.ME SNIPPET — disable auto-scroll, enable touch swipe  */
/* ============================================================ */
(function() {
  function initSnippetSwipe() {
    const wrapper = document.querySelector('.jdgm-review-snippet-widget');
    if (!wrapper) return;

    // Stop Judge.me's auto-scroll by clearing its interval
    const highestId = setInterval(() => {}, 0);
    for (let i = 0; i < highestId; i++) clearInterval(i);

    // Add touch swipe to the container
    const container = wrapper.querySelector('.jdgm-rev-snippet-widget__cards-container');
    if (!container) return;

    let startX = 0;
    container.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;     /* record finger start position */
    }, { passive: true });

    container.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 30) return;   /* ignore tiny taps */
      const btn = diff > 0
        ? wrapper.querySelector('.jdgm-rev-snippet-widget__next-btn')
        : wrapper.querySelector('.jdgm-rev-snippet-widget__prev-btn');
      if (btn) btn.click();              /* trigger Judge.me's own next/prev logic */
    }, { passive: true });
  }

  // Run after Judge.me has loaded
  if (document.readyState === 'complete') {
    setTimeout(initSnippetSwipe, 1000);
  } else {
    window.addEventListener('load', () => setTimeout(initSnippetSwipe, 1000));
  }

})();

// ============================================================
  // CART DRAWER — free gift styling (EG Auto Add to Cart + Recharge)
  // Targets the £0.00 / "Saving 100%" line item added by EG Auto Add.
  // 1) Hides the "Upgrade to subscription" banner on the free gift row only
  //    (paid items keep their upgrade banner — only the free gift is changed)
  // 2) Adds a "FREE GIFT" label below the product title on the free gift row
  // Recharge cart drawer lives in a shadow DOM, so CSS in theme.css can't
  // reach it. We re-run on every mutation because the drawer rebuilds its
  // DOM whenever items change (qty +/-, add, remove).
  // ============================================================
  function initFreeGiftStyling() {
    var drawer = document.getElementById('recharge-storefront-experiences__cart-drawer');
    if (!drawer || !drawer.shadowRoot) {
      // Drawer not in DOM yet — poll until it appears (up to ~15 seconds)
      var attempts = 0;
      var poll = setInterval(function() {
        attempts++;
        var d = document.getElementById('recharge-storefront-experiences__cart-drawer');
        if ((d && d.shadowRoot) || attempts > 60) {
          clearInterval(poll);
          if (d && d.shadowRoot) startFreeGiftStyling(d.shadowRoot);
        }
      }, 250);
      return;
    }
    startFreeGiftStyling(drawer.shadowRoot);
  }

  function startFreeGiftStyling(shadow) {
    function applyStyling() {
      var rows = shadow.querySelectorAll('div.flex.flex-col.py-6');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        // Free gift row is uniquely identified by "Saving 100%" text
        if (row.textContent.indexOf('Saving 100%') === -1) continue;

        // -- Hide the "Upgrade to subscription" button on this row --
        var buttons = row.querySelectorAll('button');
        for (var j = 0; j < buttons.length; j++) {
          var btn = buttons[j];
          if (btn.textContent.trim().toLowerCase().indexOf('upgrade to subscription') === 0) {
            var wrapper = btn.closest('div.flex.gap-2.flex-col.items-start.w-full') || btn.parentElement;
            if (wrapper) wrapper.style.display = 'none';
          }
        }

        // -- Inject "FREE GIFT" label below the product title --
        var titleEl = row.querySelector('p.font-semibold');
        if (titleEl && titleEl.parentElement && !titleEl.parentElement.querySelector('.hh-free-gift-label')) {
          var label = document.createElement('span');
          label.className = 'hh-free-gift-label';
          label.textContent = 'FREE GIFT';
          label.style.cssText = [
            'display:inline-block',
            'background:#0f5132',          /* dark green pill — change here to restyle */
            'color:#ffffff',               /* label text colour */
            'font-size:10px',
            'font-weight:700',
            'letter-spacing:0.5px',
            'padding:3px 8px',
            'border-radius:4px',
            'margin-top:4px',
            'width:fit-content',
            'text-transform:uppercase'
          ].join(';');
          titleEl.parentElement.insertBefore(label, titleEl.nextSibling);
        }
      }
    }
    applyStyling();
    // Re-run on every DOM change inside the cart drawer
    var observer = new MutationObserver(applyStyling);
    observer.observe(shadow, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', initFreeGiftStyling);
  // ============================================================
  // END — free gift styling
  // ============================================================
  
// ============================================================
  // CART DRAWER — sync the Check Out button + tidy the currency
  // ------------------------------------------------------------
  // 1) The theme updates the Subtotal on cart change but NOT the
  //    amount on the Check Out button, so the button stays stale
  //    until a page refresh. We mirror the Subtotal onto it.
  // 2) The Subtotal uses Shopify's "money_with_currency" format,
  //    which adds the ISO code (e.g. "53,55 lei RON"). We strip
  //    that trailing code so both the Subtotal and the button
  //    read just "53,55 lei". Stripping a trailing 3-letter code
  //    keeps this correct in any market (never touches "lei").
  // ============================================================
  function initCheckoutTotalSync() {
    function bind(drawer) {
      function sync() {
        var source = drawer.querySelector('.hh-foot__row--total [data-cart-final]'); // Subtotal
        var target = drawer.querySelector('.hh-checkout [data-cart-final]');          // Check Out button
        if (!source) return;
        // Drop the trailing ISO currency code: "53,55 lei RON" -> "53,55 lei"
        var clean = source.textContent.replace(/\s+[A-Z]{3}\s*$/, '').trim();
        if (source.textContent !== clean) source.textContent = clean; // tidy Subtotal
        if (target && target.textContent !== clean) target.textContent = clean; // and the button
      }
      sync(); // run once on load
      new MutationObserver(sync).observe(drawer, { childList: true, subtree: true, characterData: true });
    }

    var drawer = document.getElementById('drawer-cart');
    if (drawer) { bind(drawer); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var d = document.getElementById('drawer-cart');
      if (d || attempts > 40) { clearInterval(poll); if (d) bind(d); }
    }, 250);
  }
  document.addEventListener('DOMContentLoaded', initCheckoutTotalSync);
  // ============================================================
  // END — checkout button total sync
  // ============================================================

// ============================================================
  // HYBRID HEALTH v2 — HEADER SHRINK ON SCROLL
  // Adds .is-scrolled to the header once you scroll past 60px.
  // ============================================================
  (function() {
    var header = document.querySelector('.theme__header');
    if (!header) return;
    function handleScroll() {
      if (window.scrollY > 60) {
        header.classList.add('is-scrolled');   // shrunk state
      } else {
        header.classList.remove('is-scrolled'); // full-size state
      }
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // run once on load in case page opens mid-scroll
  })();
  
})();